<template>
  <div class="footer-box">微信公众号【爆米花小布】 | Copyright © 闽ICP备19017889号-1</div>
</template>
<script>
export default {

}
</script>
<style scoped lang="scss">
.footer-box {
  width: 100%;
  height: $LayoutFooterHeight;
  line-height: $LayoutFooterHeight;
  background: #fff;
  text-align: center;
  color: #4e6e8e;
  border-top: 1px solid #eaecef;
  font-size: 16px;
}
</style>